var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "error-layout" } }, [
    _vm.$maDomain
      ? _c("div", { staticClass: "container" }, [
          _c("p", { staticClass: "headline-large gray" }, [
            _vm._v(_vm._s(_vm.$t("errorView.title"))),
          ]),
          !_vm.isBackendError
            ? _c(
                "div",
                { staticClass: "container-img" },
                [
                  _c("img", {
                    staticClass: "center",
                    attrs: {
                      src: require("@/assets/images/self-care/otp.png"),
                    },
                  }),
                  _c("p", { staticClass: "text-medium gray mg mg--t-5" }, [
                    _vm._v(_vm._s(_vm.$t("errorView.technicalBody"))),
                  ]),
                  _c("i18n", {
                    staticClass: "text-medium gray mg mg--t-2",
                    attrs: { path: "errorView.callAction", tag: "p" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "phone",
                          fn: function () {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass: "blue-text-link",
                                  attrs: { href: _vm.phoneContactHref },
                                },
                                [_vm._v(_vm._s(_vm.phoneContactNumber))]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1317102006
                    ),
                  }),
                  _c("p", { staticClass: "text-medium gray mg mg--t-5" }, [
                    _vm._v(_vm._s(_vm.$t("errorView.thanksTechnicalText"))),
                  ]),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "container-img" },
                [
                  _c("img", {
                    staticClass: "center",
                    attrs: {
                      src: require("@/assets/images/self-care/otp.png"),
                    },
                  }),
                  _c("i18n", {
                    staticClass: "text-medium gray mg mg--t-2",
                    attrs: { path: "errorView.backendBody", tag: "p" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "phone",
                          fn: function () {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass: "blue-text-link",
                                  attrs: { href: _vm.phoneContactHref },
                                },
                                [_vm._v(_vm._s(_vm.phoneContactNumber))]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1317102006
                    ),
                  }),
                  _c("p", { staticClass: "text-medium gray mg mg--t-5" }, [
                    _vm._v(_vm._s(_vm.$t("errorView.thanksBackendText"))),
                  ]),
                ],
                1
              ),
        ])
      : _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "container-img" }, [
            _c("p", { staticClass: "headline-large gray mg mg--b-4" }, [
              _vm._v(_vm._s(_vm.$t("errorView.allianz.text"))),
            ]),
            _c(
              "p",
              {
                staticClass: "headline-medium-regular gray mg mg--b-4 margin-a",
              },
              [_vm._v(_vm._s(_vm.$t("errorView.allianz.text1")))]
            ),
            _c(
              "p",
              { staticClass: "text-large-regular gray mg mg--b-4 margin-a" },
              [_vm._v(_vm._s(_vm.$t("errorView.allianz.text2")))]
            ),
            _c("img", {
              staticClass: "end-image",
              attrs: { src: require("@/assets/end_background_img.jpeg") },
            }),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }